export const translationEsEs = {
	globals: {
		title_header: 'RUMI - Registro unificado de maltrato infantil',
		anterior: 'Anterior',
		seguent: 'Siguiente',
		imprimir: 'Imprimir',
		tancar: 'Cerrar'
	},
	home: {
		benvinguda: 'BIENVENIDO/A al Sistema de soporte a la gestión del riesgo social en la infancia y la adolescencia',
		que_es: '¿Qué es el sistema?',
		que_preten: '¿Qué pretende?',
		que_permet: '¿Qué permite?',
		com_funciona: '¿Cómo funciona?',
		simulacio: 'Simulación'
	},
	inici_simulacio: {

	},
	questionari_observacions: {

	},
	apreciacio_gravetat: {

	},
	valoracions_finals: {

	},
	altres_observacions: {

	},
	resultat_risc: {

	},
	accions: {

	}
};
